import { type FlexProps } from '@ironhack/design-system2/components/flex';
import { isEmpty, join, map, pathOr, pipe, propOr, reject, slice } from 'ramda';
import { type ReactElement } from 'react';

import { ModuleWrapper } from '@/app/components/client/module-wrapper';
import {
  QuizMatchHeader,
  type QuizMatchHeaderData,
} from '@/app/components/server/quiz-match-header';
import { CallToActionForm } from './form';
import { type SelectedCourseAnswer } from '../icon-question';
import { type ImageAnswer } from '../image-question/image-answer';

type Props = {
  answers: Array<SelectedCourseAnswer | ImageAnswer>;
  color: string;
  data: {
    form: CallToActionForm;
    screen: QuizMatchHeaderData;
  };
  sessionProfile?: QuizMatchHeaderData;
} & FlexProps;

export const CallToAction = (props: Props): ReactElement => {
  const {
    answers,
    color,
    data: { form, screen },
    ...flexProps
  } = props;

  const summaryImage =
    answers[1] && 'image' in answers[1] ? answers[1].image : null;

  const heading = pipe(
    slice(0, 2) as (
      a: Array<SelectedCourseAnswer | ImageAnswer>
    ) => ImageAnswer[],
    map(propOr('', 'summaryText')),
    reject(isEmpty),
    join(' ')
  )(answers);

  const textLines = pipe(
    slice(2, Number.POSITIVE_INFINITY) as (
      a: Array<SelectedCourseAnswer | ImageAnswer>
    ) => SelectedCourseAnswer[],
    map(pathOr('', ['answer', 'summaryText'])),
    reject(isEmpty)
  )(answers);

  const sessionProfile = {
    ...(summaryImage && { summaryImage }),
    summaryProfile: { heading, textLines },
  };

  return (
    <ModuleWrapper
      innerProps={{
        align: 'center',
        color,
        direction: 'column',
        gap: 4,
        ...flexProps,
      }}
      moduleFormat={{
        background: 'transparent',
        spacingBottom: '24',
        spacingTop: '0',
      }}
    >
      <QuizMatchHeader data={{ ...screen, ...sessionProfile }} showTitleIcon />
      <CallToActionForm
        answers={answers}
        data={form}
        sessionProfile={sessionProfile}
      />
    </ModuleWrapper>
  );
};
